import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom"
import Adopt from "./pages/Adopt"
import Header from "./Components/Header"
import Footer from "./Components/Footer"
import TermAndCondtion from "./pages/TermAndCondtion"
import About from "./pages/About"
import Contact from "./pages/Contact"
import AdoptPage from "./pages/AdoptPage"
import Boarding from "./pages/Boarding"
import Home from "./pages/Home"
import TrainingSchool from "./pages/TrainingSchool"
import DonatePage from "./pages/DonatePage"
import AdoptionForm from "./Components/AdoptionForm"
import GuardianForm from "./pages/GuardianForm"

const AppLayout = () => (
  <div className="overflow-x-hidden font-roboto">
    <Header />
    <Outlet />
    <Footer/>
  </div>
);

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout/>,

    children: [
      {
        path:"/",
        element: <Home/>
      },
      {
        path:"/adopt",
        element:<Adopt/>
      },
      {
        path:"/term-condition",
        element:<TermAndCondtion/>
      },
      // {
      //   path:"/taxes",
      //   element:<Taxes/>
      // },
      {
        path:"/about",
        element : <About/>
      },
      {
        path:"/contact",
        element:<Contact/>
      },
      {
        path:"/AdoptPage",
        element:<AdoptPage/>
      },
      {
        path:"/Boarding",
        element: <Boarding/>,
      },
      {
        path:"/Training_school",
        element: <TrainingSchool/>
      },
      
      {
        path:"/page-donate",
        element:<DonatePage/>
      },
      {
        path:"/adoption-form",
        element:<AdoptionForm/>
      },
      {
        path:"/guardian/guardian-form",
        element:<GuardianForm/>
      }
    ]
  }
  
])

function App() {
  return (
    <div className="overflow-x-hidden font-roboto">
      <RouterProvider router={appRouter}/>
    </div>
  );
}

export default App;
